<template>
  <!-- EDIT STAFF -->
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="editStaffModal"
      persistent
      max-width="900px"
    >
      <v-card>
        <form
          action=""
          @submit.prevent="submitForm"
        >
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            ><span class="headline">Update staff</span></v-flex>
            <v-flex
              xs1
              sm1
              md1
            >
              <v-btn
                flat
                @click="closeEditStaffModal(), $validator.reset()"
                class="close"
              >&times;</v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="checkAlert"
            >
              Staff updated successfully
            </v-alert>
            <v-alert
              type="error"
              :value="validationError"
            >
              {{ emailError }}
            </v-alert>
            <v-alert
              type="error"
              :value="backendError"
            >
              Please update anything
            </v-alert>
            <v-layout wrap>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  label="Full Name"
                  v-model="editStaffData.full_name"
                  :error-messages="errors.collect('Full Name')"
                  v-validate="'required'"
                  data-vv-name="Full Name"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  label="Email"
                  v-model="editStaffData.email"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  label="Phone Number"
                  v-model="editStaffData.phone_number"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  label="Address"
                  v-model="editStaffData.address"
                >
                </v-text-field>
              </v-flex>

              <!-- <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="editStaffData.default_branch_id_fk"
                  :error-messages="errors.collect('Default Branch')"
                  data-vv-name="Default Branch"
                  label="Default Branch*"
                  v-validate="'required'"
                >
                </v-select>
              </v-flex> -->

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="roles"
                  item-value="value"
                  v-model="editStaffData.rolesId"
                  :error-messages="errors.collect('roles')"
                  data-vv-name="roles"
                  label="Role*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                  autocomplete
                >
                </v-select>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  v-model="editStaffData.warehouse_id_fk"
                  :error-messages="errors.collect('Warehouse')"
                  data-vv-name="Warehouse"
                  label="Warehouse*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex>

              <!-- <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="editStaffData.branchesId"
                  :error-messages="errors.collect('Branch')"
                  data-vv-name="Branch"
                  label="Branch*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeEditStaffModal(), $validator.reset()"
              outline
              color="normal"
            >Cancel</v-btn>
            <v-btn
              type="submit"
              style="height:auto; margin-right: 2.5%"
              outline
              color="success"
            >Update</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /EDIT STAFF -->
</template>

<script>
export default {
  props: [
    'editStaff',
    'roles',
    'warehouses',
    'branches',
    'editStaffData',
    'editStaffModal',
    'checkAlert',
    'closeEditStaffModal',
    'emailError',
    'validationError',
    'backendError'
  ],

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editStaff()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editStaff.vue